import axios from "axios";
import { api } from "./helper";
import store from "../store"

const client = axios.create({
  baseURL: api,
  withCredentials: false,
});

client.interceptors.request.use((config) => {
  config.headers.Authorization = "Bearer " + store.state.user.jwt;
  return config;
});

client.interceptors.response.use(
  (response) => {
    if (!response.data)
      if (response.data.indexOf("Unauthorized") > -1) {
        router.push("/logout");
      }
    return response;
  },
  (error) => {
    return { data: error.message };
    // return Promise.reject(error.response);
  }
);
function UploadFile(formData) {
  return client.post("Upload", formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}
function Create(file) {
  return client.post("Files", file);
}

async function GetFiles(sourcetype, sourceId, sourcedetId, uid) {
  const params = {
    sourcetype: sourcetype,
    sourceId: sourceId,
    sourcedetId: sourcedetId,
    commandUserId: uid,
  };
  
  try {
    const response = await client.get("Files", { params });
    return response.data; 
  
  } catch (error) {
    console.error("Error fetching files:", error);
    throw new Error(error.response?.data?.message || 'An error occurred.');
  }
}

function Delete(id,uid) {
  var item = { id: id, commandUserId: uid };
  return client.delete("Files", { data: item });
}

export { Create, GetFiles, Delete,UploadFile };
